import { createFileRoute } from '@tanstack/react-router';

// Scaffold — tenant switcher + list (full implementation in a follow-up task).
export const Route = createFileRoute('/_authenticated/tenants/')({
  component: TenantsPage,
});

function TenantsPage() {
  return <div className="p-8">Tenants</div>;
}
